import styled from 'styled-components';

const Body1 = styled.div`
  font-size: 18px;
  line-height: 26px;
`;

const Body2 = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

const Body3 = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

const Button = styled.button`
  box-sizing: border-box;
  outline: none;
  background: #FFFFFF;
  color: #1253FA;
  height: 40px;
  padding: 0 20px;
  border: 1px solid #1253FA;
  ${({ large }) => large && `height: 48px;`}

  &:hover {
    cursor: pointer;
    color: #124BDF;
    border-color: #124BDF;
  }
`;

const Caption = styled.div`
  font-size: 12px;
  line-height: 16px;
`;

const ComponentHeadline = styled.div`
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.88px;
  line-height: 28px;
`;

const CtaButton = styled.button`
  background: white;
  color: #08111e;
  width: 240px;
  height: 50px;
  padding: 0;
  border: none;
  border-radius: 25px;
  outline: none;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1.1px;
  line-height: 49px;
  text-transform: uppercase;

  &:hover {
    background: #dddddd;
    cursor: pointer;
  }

  &:active {
    background: #aaaaaa;
  }
`;

const H2 = styled.div`
  font-size: 38px;
  line-height: 46px;
  font-weight: 500;
  margin-bottom: 40px;
`;

const H3 = styled.div`
  font-size: 28px;
  line-height: 40px;
`;

const H4 = styled.div`
  font-size: 22px;
  line-height: 32px;
`;

const StandardHeadline = styled.div`
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  letter-spacing: 1.12px;
`;

const SectionHeading = styled.div`
  color: #b0b0b0;
  font-weight: 700;
  font-size: 16px;
  line-height: 38px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
`;

const SectionHeadline = styled(StandardHeadline)`
  line-height: 38px;
`;

const TextInput = styled.input`
  outline: none;
  box-sizing: border-box;
  height: 40px;
  width: 100%;
  padding: 0 14px;
  border: 1px solid #E7EAF3;
  border-radius: 2px;
  font-size: 14px;
  line-height: 20px;
  ${({ large }) => large && `height: 48px;`}

  &:hover {
    border-color: #1253FA;
  }

  &:active {
    border-color: #1253FA;
  }
`;

export {
  Body1,
  Body2,
  Body3,
  Button,
  Caption,
  ComponentHeadline,
  CtaButton,
  H2,
  H3,
  H4,
  SectionHeading,
  SectionHeadline,
  StandardHeadline,
  TextInput,
};
